import dayjs from 'dayjs';

export const isSameMinute = (
  date1: Date | string,
  date2: Date | string,
): boolean => dayjs(date1).isSame(dayjs(date2), 'minute');
